import { Data } from 'interfaces/ApolloResponse.interface'

export default ({ system: { refId } }: Data, tenantContext?: string) => {
  const isAffiliate = !!refId || tenantContext === 'external'

  return !isAffiliate
}
